import { Api } from '@/services/Api'

export default {
  getInverterReport(param) {
    return Api().post('/api/v1.0/report-inverter', param)
  },
  getScbReport(param) {
    return Api().post('/api/v1.0/report-scb', param)
  },
  getWsReport(param) {
    return Api().post('/api/v1.0/report-ws', param)
  },
  getMfmReport(param) {
    return Api().post('/api/v1.0/report-mfm', param)
  },
  getReport(param) {
    return Api().post('/api/v2/report', param)
  },
  getReportOpt(param, reportName) {
    return Api().request({
      url: `/api/v2/report/download/${param}`,
      method: 'GET',
      responseType: 'blob'
    }).then(response => {
      const filename = reportName + (new Date()).getTime() + '.csv.gz'
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    })
  },
  fetchReportCSV(param) {
    return Api().post('/api/v1.0/report/download', param)
  }
}
